<template>

  <app-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="extra-large"
  >

  <template slot="header">
      <h5 class="modal-title">{{ modalTitle }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/employee/${inputs.id}`
            : `/employee`
        "
      >
        <div class="form-group row">
          <div class="col-12">
            <app-note
              note-type="note-red"
              :show-title="false"
              :notes="formNoteInstruction"
            />
          </div>
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_first_name" class="col-sm-3 mb-0">
            Nombres <b class="text-danger" style="font-size:18px !important;">*</b>
          </label>
          <app-input type="text"
                  id="inputs_first_name"
                  class="col-sm-9"
                  v-model="inputs.first_name"
                  :required="true"
                  placeholder="Ingrese Nombres"/>
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_last_name" class="col-sm-3 mb-0">
            Apellidos <b class="text-danger" style="font-size:18px !important;">*</b>
          </label>
          <app-input type="text"
                  id="inputs_last_name"
                  class="col-sm-9"
                  v-model="inputs.last_name"
                  :required="true"
                  placeholder="Ingrese Apellidos"/>
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_username" class="col-sm-3 mb-0">
            Nombre de Usuario <b class="text-danger" style="font-size:18px !important;">*</b>
          </label>
          <app-input type="text"
                  id="inputs_username"
                  class="col-sm-9"
                  :min-length=5
                  v-model="inputs.username"
                  :required="true"
                  @input="textToLower"
                  @blur="handleBlurUsername"
                  placeholder="Ingrese Nombre de usuario"/>
        </div>

        <br>

        <app-note class="pt-2 clearfix"
          title="Nota sobre el Nombre de Usuario"
          content-type="html"
          note-type="note-info"
          :notes="[$t('Debe de ser solo minúsculas, sin espacios, mínimo de 5 caracteres y máximo de 15 caracteres <b>Sugerencia:</b> primera letra del nombre + apellido. <b>Ejemplo:</b> usuariouno | pperez123')]"
        />

        <br>

        <div class="form-group row align-items-center">
          <label for="inputs_taxid_type" class="col-sm-3 mb-0">
            Tipo Identificación <b class="text-danger" style="font-size:18px !important;">*</b>
          </label>
          <app-input
            id="inputs_taxid_type"
            class="col-sm-9"
            type="select"
            v-model="inputs.taxid_type"
            :list="taxidTypeLists"
            v-on:change="onChangeTaxIdType"
            :required="true"
          />
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_taxid" class="col-sm-3 mb-0">
            Identificación <b class="text-danger" style="font-size:18px !important;">*</b>
          </label>
          <app-input type="text"
                  id="inputs_taxid"
                  class="col-sm-9"
                  v-model="inputs.taxid"
                  :min-length=1
                  :disabled="isDisabled"
                  v-on:keypress="isNumber"
                  @blur="handleBlurCI"
                  :required="true"
                  placeholder="Ingrese Identificación"/>
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_email" class="col-sm-3 mb-0">
            Correo Electrónico <b class="text-danger" style="font-size:18px !important;">*</b>
          </label>
          <app-input type="text"
                  id="inputs_email"
                  class="col-sm-9"
                  v-model="inputs.email"
                  @blur="handleBlurEmail"
                  :required="true"
                  placeholder="Ingrese Correo Electrónico"/>
          <span class="text-danger" v-if="msgEmail"> {{ msgEmail }}</span>
        </div>

        <div class="form-group row align-items-center">
          <label class="col-sm-3 mb-0">
            Teléfono Fijo
          </label>
          <app-input type="tel-input"
                  class="col-sm-9"
                  id="inputs_phone_employee"
                  v-model="inputs.phone"
                  placeholder="Ingrese Teléfono Fijo"/>
        </div>

        <div class="form-group row align-items-center">
          <label class="col-sm-3 mb-0">
            Celular <b class="text-danger" style="font-size:18px !important;">*</b>
          </label>
          <app-input type="tel-input"
                  class="col-sm-9"
                  v-model="inputs.cellphone"
                  :required="true"
                  placeholder="Ingrese Teléfono Fijo"/>
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_accreditation_area_id" class="col-sm-3 mb-0">
            Área <b class="text-danger" style="font-size:18px !important;">*</b>
          </label>
          <div class="col-sm-9">
            <multiselect
              v-model="inputs.oae_accreditation_area"
              :options="accreditationAreaList"
              placeholder="Seleccione una opción"
              label="value"
              :required="true"
            ></multiselect>
          </div>
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_position_id" class="col-sm-3 mb-0">
            Cargo <b class="text-danger" style="font-size:18px !important;">*</b>
          </label>
          <div class="col-sm-9">
            <multiselect
              v-model="inputs.oae_position"
              :options="positionsList"
              placeholder="Seleccione una opción"
              label="value"
              :required="true"
            ></multiselect>
          </div>
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_role_id" class="col-sm-3 mb-0">
            Rol <b class="text-danger" style="font-size:18px !important;">*</b>
          </label>
          <app-input
            class="col-sm-9"
            type="multi-select"
            :list="roleList"
            :isAnimatedDropdown="true"
            v-model="inputs.multiSelectRole"
          />
        </div>
        <br>

      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="submit"
              class="btn btn-primary"
              @click.prevent="submit"
              :disabled="disabledSubmit">
        Guardar
      </button>
    </template>

  </app-modal>
</template>

<script>
  import { FormMixin } from "@/core/mixins/form/FormMixin.js";
  import { ModalMixin } from "@/app/Mixins/ModalMixin";
  import * as actions from "../../../apiUrl";
  import Multiselect from "vue-multiselect";

  export default {
    name: "EmployeeAddModal",
    components: { Multiselect },
    mixins: [FormMixin, ModalMixin],
    props: {
      tableId: String,
      accreditationAreaList: Array,
      positionsList: Array,
      roleList: Array
    },
    data() {
      return {
        preloader: false,
        isDisabled: true,
        disabledSubmit: false,
        inputs: {
          multiSelectRole: []
        },
        msgEmail: '',
        formNoteInstruction: [
          this.$t('Todos los campos con un (*) son obligatorios.'),
        ],
        modalId: "employee-add-edit-modal",
        modalTitle: '',
        taxidTypeLists: [
            {id: '', value: "Seleccione"},
            {id: 'ci', value: "Cédula de Identidad"},
            {id: 'other', value: "Pasaporte"},
        ]
      };
    },
    watch: {
      "inputs.email": function () {
          let email = this.inputs.email;
          this.validateEmailInput(email);
      },
    },
    created() {
      if (this.selectedUrl) {
        this.modalTitle = 'Editar Empleado';
        this.preloader = true;
      }else{
        this.modalTitle = 'Añadir Empleado'
      }
    },
    methods: {
      afterJsValidationFail() {
        this.disabledSubmit = false;
        this.$toastr.e("Algunos campos del formulario tienen errores o no han sido completados.");
      },
      textToLower(val) {
        this.inputs.username = val.toLowerCase().trim();
      },
      handleBlurUsername(e) {
          this.validateUsername();
      },
      validateUsername(){
          this.preloader = true;
          let url = `${actions.USERS_REGISTER}/validateUsername/${this.inputs.username}`;
          this.axiosGet(url)
              .then((response) => {
                  if (response.status == 200) {
                      if(!response.data.validate){
                          this.inputs.username = null;
                          this.$toastr.e(response.data.message);
                      }
                  }
              })
              .catch(({ error }) => {
                  console.log(error);
              })
              .finally(() => {
                  this.preloader = false;
              });
      },
      handleBlurEmail(e) {
          this.validateEmail();
      },
      validateEmail(){
          this.preloader = true;
          let url = `${actions.USERS_REGISTER}/validateEmail/${this.inputs.email}`;
          this.axiosGet(url)
              .then((response) => {
                  if (response.status == 200) {
                      if(!response.data.validate){
                          this.inputs.email = null;
                          this.$toastr.e(response.data.message);
                      }
                  }
              })
              .catch(({ error }) => {
                  console.log(error);
              })
              .finally(() => {
                  this.preloader = false;
              });
      },
      validateEmailInput(value){
          if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)){
            this.msgEmail = '';
          } else{
            this.msgEmail = 'Dirección de correo electrónico no válida';
          }
      },
      isNumber: function(evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
              evt.preventDefault();;
          } else {
              return true;
          }
      },
      handleBlurCI(e) {
        if(this.inputs.taxid_type === 'ci'){
          this.validateTaxid();
        }
      },
      validateTaxid(){
        this.preloader = true;
        let type = 'ci';
        if(!this.inputs.taxid){
          this.$toastr.e("Debe ingresar un valor válido para el campo cédula.");
          this.preloader = false;
        }else{
          let url = `${actions.USERS_REGISTER}/validate/${this.inputs.taxid}/${type}`;
          this.axiosGet(url)
              .then((response) => {
                  if (response.status == 200) {
                      if(!response.data.validate){
                          this.inputs.taxid = null;
                          this.$toastr.e(response.data.message);
                      }
                  }
              })
              .catch(({ error }) => {
                  console.log(error);
              })
              .finally(() => {
                  this.preloader = false;
              });
        }
      },
      submit() {
        const tmp = this.inputs;
        if(!tmp.oae_accreditation_area){
          this.$toastr.e('Debe de seleccionar el Área.');
          return;
        }
        if(!tmp.oae_position){
          this.$toastr.e('Debe de seleccionar el Cargo.');
          return;
        }
        if(tmp.multiSelectRole && tmp.multiSelectRole.length === 0){
          this.$toastr.e('Debe de seleccionar al menos un rol para el empleado.');
          return;
        }
        tmp.oae_position_id = tmp.oae_position.id,
        tmp.oae_accreditation_area_id = tmp.oae_accreditation_area.id,
        this.inputs = tmp;
        this.disabledSubmit = true;
        this.save(this.inputs);
      },
      afterSuccess(response) {
        if (response.status == 200) {
          if(this.inputs.id){
            this.$toastr.s('Empleado actualizado exitosamente.');
          }else{
            this.$toastr.s('Empleado creado exitosamente.');
          }
        }
        this.$hub.$emit("reload-" + this.tableId);
      },
      afterSuccessFromGetEditData(response) {
        const tmp = response.data;
        if(!response.data.phone) tmp.phone = '';
        tmp.multiSelectRole = response.data.roles.map(
          (item) => item.id
        );
        tmp.oae_position = response.data.position;
        tmp.oae_accreditation_area = response.data.area;
        this.inputs = tmp;
        this.preloader = false;
      },
      onChangeTaxIdType(){
          if(this.inputs.taxid_type){
              this.isDisabled = false;
              if(this.inputs.taxid && this.inputs.taxid_type === 'ci'){
                this.validateTaxid();
              }
          }else{
              this.isDisabled = true;
          }
      },
    },
  };
</script>
